import 'slick-carousel/slick/slick.css';
import Instafeed from 'instafeed.js';
require('slick-carousel/slick/slick.js');

export default class InstafeedSlider {
  constructor(el, useDifferent) {
    this.el = el;
    var count = useDifferent ? 2 : 4;

    var feed = new Instafeed({
      get: 'user',
      userId: '1482040657',
      accessToken: '1482040657.1677ed0.a1a7aac07d044b5b98317d276bde51a4',
      clientId: '5046e2063c16463c91b860e37d5546d0',
      resolution: 'standard_resolution',
      template:
        '<li><a target="_blank" style="background-image: url({{image}});" href="{{link}}" class="insta-slide"><div class="caption"><span>{{caption}}</span></div></a></li>',
      limit: 30,
      sortBy: 'most-recent',
      after: function(data) {
        el.on('init', function() {
          // $(this).find('.slick-slide a .caption, .slick-slide a').height($(this).find('.slick-slide a').width());
          // $(this).find('.slick-slide a .caption span').each(function () {
          //     $(this).text($(this).text().substring(0, 140));
          // });
        });
        el.slick({
          dots: false,
          infinite: true,
          speed: 1000,
          autoplay: true,
          slidesToShow: count,
          slidesToScroll: count / 2,
          arrows: false,
          vertical: true,
          verticalSwiping: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });
      },
    });
    feed.run();
  }
}



// WEBPACK FOOTER //
// ./app/components/instafeedSlider.js